import { create } from 'zustand';
import { pickWowMoment, readWowMemory, recordWowShown } from '@/utils/codeNextWow';
import { track } from '@/services/learnerEvents';

/**
 * The Code Next "wow" moment (ADO #574) — which one is open, if any.
 *
 * Three surfaces grade a build: the Solution Page's Submit, the builder's
 * Tests panel Submit, and the capstone story runner. Each hands its verdict
 * and the exact files it submitted to `offerCodeNextWow`; the one host mounted
 * in App renders the dialog. Keeping the decision here means the rules live in
 * one place (utils/codeNextWow) whichever surface the pass came from.
 */
const useCodeNextWowStore = create((set) => ({
  // { moment, module, ref, capstoneTitle, flows, filesDict, mainFile } while open, else null.
  wow: null,
  open: (wow) => set({ wow }),
  close: () => set({ wow: null }),
}));

/**
 * Offer the moment for one graded attempt. Opens it, remembers it and records
 * `codenext.wow_shown` when the rules allow; otherwise does nothing.
 * Never throws — a pass must never be spoiled by its celebration.
 *
 * @returns {boolean} whether the moment opened
 */
export function offerCodeNextWow({ verdict, ref, flows, filesDict, mainFile = null }) {
  try {
    if (useCodeNextWowStore.getState().wow) return false;
    if (!filesDict || !Object.keys(filesDict).length) return false;
    const pick = pickWowMoment({ verdict, ref, memory: readWowMemory() });
    if (!pick) return false;
    recordWowShown(pick.moment);
    track('codenext.wow_shown', pick.ref, { module: pick.module, moment: pick.moment });
    useCodeNextWowStore.getState().open({ ...pick, flows: flows || [], filesDict, mainFile });
    return true;
  } catch (err) {
    console.warn('Code Next moment skipped', err);
    return false;
  }
}

export default useCodeNextWowStore;
